import { AppIdvAcceptableDocumentsResponseSchema } from "@amzn/client-workbench-api-model";
import { AxiosError } from "axios";
import { useContext } from "react";
import { useQuery, UseQueryResult } from "react-query";

import {
  fetchIdvAcceptableDocuments,
  GET_IDV_DOCUMENTS_METRIC_NAME,
} from "@/apis/IdvAcceptableDocumentsHelper";
import { getRetryDelayMs, shouldRetry } from "@/helpers/react-query-helper";
import { AppContext } from "@/stores/appStore";

/**
 * Custom hook to fetch the IDV acceptable document countries and types and set it in the global app state.
 */
export const useIdvAcceptableDocs = function (): UseQueryResult<
  AppIdvAcceptableDocumentsResponseSchema,
  AxiosError | Error
> {
  const { state } = useContext(AppContext);
  return useQuery(GET_IDV_DOCUMENTS_METRIC_NAME, fetchIdvAcceptableDocuments, {
    retry: (failureCount, err) => shouldRetry(failureCount, err),
    retryDelay: (retryCount) => getRetryDelayMs(retryCount),
    // Run the query only if amplify has been configured
    enabled: state.amplifyConfigured,
  });
};
